import { ContentRoutes } from 'enums/routes';
import { AccessTypes, MethodTypes, PermissionTypes } from 'enums/types';
import useUser from 'stores/useUser';

const accessByPermission = {
  [PermissionTypes.Allow]: AccessTypes.Allow,
  [PermissionTypes.Blocked]: AccessTypes.Disallow,
  [PermissionTypes.Disallow]: AccessTypes.Disallow,
  [PermissionTypes.Related]: AccessTypes.Related,
};

const onlyWithTenant = [
  ContentRoutes.Roles,
];

const superUserContents: string[] = [ContentRoutes.SuperUsers];
export const policy = (content:string) => (method: MethodTypes): AccessTypes => {
  const { user } = useUser.getState();
  if (user?.isSuperUser) {
    if (method !== MethodTypes.View) {
      if (onlyWithTenant.includes(content as ContentRoutes)) {
        return AccessTypes.Disallow;
      }
    }
    return AccessTypes.Allow;
  }
  if (method === MethodTypes.SuperUser) {
    return AccessTypes.Disallow;
  }

  if (superUserContents.includes(content)) {
    return AccessTypes.Disallow;
  }
  return accessByPermission?.[user?.role?.permissions?.[content]?.[method]] || AccessTypes.Allow;
};
